<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M2 5C2 3.89543 2.89543 3 4 3H19.2C20.3046 3 21.2 3.89543 21.2 5V6.6H2V5Z"
      :fill="color"
    />
    <path
      d="M2 7.7998H21.2V18.9998C21.2 20.1044 20.3046 20.9998 19.2 20.9998H4C2.89543 20.9998 2 20.1044 2 18.9998V7.7998Z"
      :fill="color"
    />
    <path
      d="M14.5 11.5C14.6707 11.2945 14.8497 11.0672 15.1117 11.015C15.1632 11.0047 15.2161 10.9996 15.2695 11C15.4604 11.0014 15.6433 11.0726 15.7795 11.1986C15.9157 11.3246 15.9947 11.4956 15.9997 11.6754C16.0048 11.8553 15.9355 12.0299 15.8065 12.1625L11.8909 16.7783C11.8235 16.8466 11.7423 16.9015 11.6519 16.9396C11.5616 16.9776 11.464 16.9982 11.3651 16.9999C11.2661 17.0016 11.1678 16.9845 11.0761 16.9496C10.9843 16.9147 10.9009 16.8627 10.831 16.7968L8.23426 14.3492C8.16195 14.2857 8.10395 14.2091 8.06372 14.124C8.02349 14.0389 8.00186 13.9471 8.00011 13.8539C7.99837 13.7608 8.01655 13.6682 8.05357 13.5819C8.09059 13.4955 8.14569 13.417 8.21558 13.3511C8.28547 13.2852 8.36872 13.2333 8.46037 13.1984C8.55202 13.1635 8.65019 13.1464 8.74901 13.148C8.84784 13.1497 8.9453 13.1701 9.03559 13.208C9.12588 13.2459 9.20713 13.3006 9.27452 13.3687L11.3295 15.3048L14.5 11.5Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
    />
  </svg>
</template>
